import styled, { css } from "styled-components";
import { shimmerTranslateX } from "../styles/animations";

export const PagePlaceholder = styled.div<{
  $minHeight?: string;
  $shimmer?: boolean;
}>`
  width: 100%;
  min-height: ${({ $minHeight }) => $minHeight ?? "100vh"};
  background: var(--bg);
  position: relative;
  overflow: hidden;

  ${({ $shimmer }) =>
    $shimmer &&
    css`
      &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(
          90deg,
          transparent 0%,
          rgba(255, 0, 102, 0.06) 50%,
          transparent 100%
        );
        animation: ${shimmerTranslateX} 1.6s ease-in-out infinite;
      }
    `}
`;
